const initialState = [];

export default function action(state = initialState, action) {

    let newState = naiveShallowCopy(state);
    var t0 = performance.now();

    switch (action.type) {
        case "ADD_FORM":

            // Just replace/add form to store
            newState = action.payload;

            return newState;
        case "ADD_SECTION":

            // Just add a section
            newState.question_sections.push(action.payload);

            console.log("Add section took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "ADD_GROUP":

            // Not sorry for that, here it´s pretty okay
            newState.question_sections.forEach(function (section) {
                if (section.id !== this.section) return;
                section.question_groups.push(this.data);
            }.bind({ section: action.section, data: action.payload }));

            console.log("Add group took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "ADD_QUESTION":

            // Sorry for that, this is possibly the most simple solution how to update nested data structure
            newState.question_sections.forEach(function (section) {
                if (section.id !== this.section) return;
                section.question_groups.forEach(function (group) {
                    if (group.id !== this.group) return;
                    group.questions.push(this.data);
                }.bind(this));
            }.bind({ data: action.payload, section: action.section, group: action.group }));

            console.log("Add question took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "ADD_ANSWER":

            // Sorry for that, this is possibly the most simple solution how to update nested data structure
            newState.question_sections.forEach(function (section) {
                if (section.id !== this.section) return;
                section.question_groups.forEach(function (group) {
                    if (group.id !== this.group) return;
                    group.questions.forEach(function (question) {
                        if (question.id !== this.question) return;
                        question.question_possible_answers.push(this.data);
                    }.bind(this));
                }.bind(this));
            }.bind({ data: action.payload, section: action.section, group: action.group, question: action.question }));

            console.log("Add answer took " + (performance.now() - t0) + " milliseconds.");

            return newState;

        case "UPDATE_SECTION":

            newState.question_sections.forEach(function (section, index, sections) {
                if (section.id !== this.data.id) return;
                if (this.remove) {
                    sections.splice(index, 1);
                } else {
                    sections[index] = this.data;
                }
            }.bind({ data: action.payload, remove: action.remove }));

            console.log("Update section took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "UPDATE_GROUP":

            
            newState.question_sections.forEach(function (section, index, sections) {
                if (section.id !== this.section) return;
                section.question_groups.forEach(function (group, group_index, groups) {
                    if (group.id !== this.data.id) return;
                    if (this.remove) {
                        groups.splice(group_index, 1);
                    } else {
                        groups[group_index] = this.data;
                    }
                }.bind(this));
            }.bind({ data: action.payload, section: action.section, remove: action.remove }));
            
            console.log("Update group took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "UPDATE_QUESTION":

            newState.question_sections.forEach(function (section, index, sections) {
                if (section.id !== this.section) return;
                section.question_groups.forEach(function (group, group_index, groups) {
                    if (group.id !== this.group) return;
                    group.questions.forEach(function (question, question_index, questions) {
                        if (question.id !== this.data.id) return;
                        if (this.remove) {
                            questions.splice(question_index, 1);
                        } else {
                            questions[question_index] = this.data;
                        }
                    }.bind(this));
                }.bind(this));
            }.bind({ data: action.payload, section: action.section, group: action.group, remove: action.remove }));

            console.log("Update question took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "REORDER_QUESTIONS":

            let section = getSection(action.section, state, true);
            let group = getGroup(action.group, section.data, state, true);

            //  Update the question position
            for (let nqi = 0; nqi < action.payload.length; nqi++) {
                action.payload[nqi]["position"] = nqi;
            }

            newState.question_sections[section.index].question_groups[group.index].questions = action.payload;

            console.log("Reorder questions took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        case "UPDATE_ANSWER":

            newState.question_sections.forEach(function (section, index, sections) {
                if (section.id !== this.section) return;
                section.question_groups.forEach(function (group, group_index, groups) {
                    if (group.id !== this.group) return;
                    group.questions.forEach(function (question, question_index, questions) {
                        if (question.id !== this.question) return;

                        question.question_possible_answers.forEach(function (answer, answer_index, answers) {
                            if (answer.id !== this.data.id) return;
                            if (this.remove) {
                                answers.splice(answer_index, 1);
                            } else {
                                answers[answer_index] = this.data;
                            }
                        }.bind(this));
                    }.bind(this));
                }.bind(this));
            }.bind({
                data: action.payload,
                section: action.section,
                group: action.group,
                question: action.question,
                remove: action.remove
            }));

            console.log("Update answer took " + (performance.now() - t0) + " milliseconds.");

            return newState;
        default:
            return state;
    }
}

/**
 * This function will copy object without any reference
 * so in our case, redux will detect change, since it does not
 * detect changes in nested objects, like our data is
 *
 * @param original
 * @returns {{}}
 */
function naiveShallowCopy(original) {
    let clone = {};
    let key;
    for (key in original) {
        clone[key] = original[key];
    }
    return clone;
}

// eslint-disable-next-line
function getSection(id, state, getIndex = false) {
    // Find index of section
    let sectionIndex = state.question_sections.findIndex(function (section) {
        return section.id === this;
    }.bind(id));

    return getIndex ? { index: sectionIndex, data: state.question_sections[sectionIndex] } : state.question_sections[sectionIndex];
}

// eslint-disable-next-line
function getGroup(id, section, state, getIndex = false) {
    // Find index of group in section
    let groupIndex = section.question_groups.findIndex(function (group) {
        return group.id === this;
    }.bind(id));

    return getIndex ? { index: groupIndex, data: section.question_groups[groupIndex] } : section.question_groups[groupIndex];
}

// eslint-disable-next-line
function getQuestion(id, group, state, getIndex = false) {
    // Find the index of question in group
    let questionIndex = group.questions.findIndex(function (cq) {
        return cq.id === this;
    }.bind(id));

    return getIndex ? { index: questionIndex, data: group.questions[questionIndex] } : group.questions[questionIndex];
}

// eslint-disable-next-line
function getPossibleAnswer(id, question, state, getIndex = false) {
    let possibleAnswerIndex = question.question_possible_answers.findIndex(function (pa) {
        return pa.id === this;
    }.bind(id));

    return getIndex ? possibleAnswerIndex : question.question_possible_answers[possibleAnswerIndex];
}


// WEBPACK FOOTER //
// ./src/redux/reducers/form.js